import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, Observable, shareReplay } from 'rxjs';

@Injectable()
@UntilDestroy()
export class MediaQueryService {
  private breakpointObserver = inject(BreakpointObserver);

  public mediaQuery(query: string): Observable<boolean> {
    return this.breakpointObserver.observe(query).pipe(
      untilDestroyed(this),
      shareReplay({ refCount: true, bufferSize: 1 }),
      map(result => result.matches)
    );
  }
}
